import React, { useState } from "react";
import { Lock } from "lucide-react";
import { api, formatApiError } from "@/lib/api";


export function UnlockGate({ onUnlocked }) {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await api.post("/graphic-studio/unlock", { code });
      onUnlocked();
    } catch (ex) {
      setErr(formatApiError(ex.response?.data?.detail) || "Incorrect code");
    } finally { setBusy(false); }
  };

  return (
    <div className="p-8 flex justify-center" data-testid="studio-unlock">
      <form onSubmit={submit} className="ccs-card w-full max-w-sm space-y-4">
        <div className="flex items-center gap-2 text-amber-400"><Lock size={16} /><span className="ccs-label">Graphic Studio</span></div>
        <h1 className="text-2xl font-semibold tracking-tight">Enter access code</h1>
        <p className="muted-text text-sm">The certificate designer is in preview. Enter the 4-digit code — you will be asked again each time you open the Studio.</p>
        <input autoFocus inputMode="numeric" maxLength={8} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          className="ccs-input ccs-input-mono text-2xl tracking-[0.5em] text-center w-full" placeholder="••••" data-testid="studio-code-input" />
        {err && <div className="text-red-400 text-xs" data-testid="studio-code-error">{err}</div>}
        <button type="submit" disabled={busy || code.length < 4} className="ccs-btn w-full" data-testid="studio-code-submit">Unlock</button>
      </form>
    </div>
  );
}
